import { Box, ButtonBase, styled } from '@planne-software/uni/mui/material';

export const MonthHeaderRoot = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  marginBottom: '1rem',
});

export const MonthArrowButton = styled(ButtonBase)(({ theme }) => ({
  backgroundColor: theme.tokens.colors['color-neutral-white'],
  border: `0.0625rem solid ${theme.tokens.colors['text-color-neutral-strong']}`,
  borderRadius: '0.5rem',
  padding: '0.5rem',
  boxShadow: theme.tokens.shadow['shadow-xs'],
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  '&.Mui-disabled': { opacity: 0.5 },
}));

export const MonthLabelChipButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'interactive',
})<{ interactive: boolean }>(({ theme, interactive }) => ({
  backgroundColor: theme.tokens.colors['color-neutral-white'],
  border: `0.0625rem solid ${theme.tokens.colors['text-color-neutral-strong']}`,
  borderRadius: '0.5rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  paddingTop: '0.5rem',
  paddingBottom: '0.5rem',
  boxShadow: theme.tokens.shadow['shadow-xs'],
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  cursor: interactive ? 'pointer' : 'default',
}));

export const MonthLabelText = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-xs-semibold'],
  color: theme.tokens.colors['text-color-neutral-strongest'],
  whiteSpace: 'nowrap',
}));
